<template>
    <div class="projects-container">
                         
                  <div class=" project-item">
                     <div class=" projects-image">
                        <img src="@/assets/restaurant.gif" alt="" srcset="">
                     </div>
                     <div class="project-description">
                         <div class="project-description-text">
                        <p>
                          This is a restaurant website concept for my practice in web-desing.
                          this website is personal it also have a night mode on it no framework used
                      </p>
                         </div>
                        <div class="description-text">
                            <p class="description-tech-title"> technologie used</p>
                            <ul class="description-tech">
                                <li>HTML5</li>
                                <li>CSS3</li>
                                <li>javascript</li>
                            </ul>
                        </div>
                        <div class="project-links">
                            <div class="btn">
                                
                                <a href="https://github.com/nila884/restaurantII/tree/master"><span class="btn-bg">see code</span></a>
                            </div>
                            <div class="btn">
                                
                                <a href="https://hightrestaurant.netlify.app/"><span class="btn-light">go to see</span></a>
                            </div>
                            
                        </div>
                     </div>
                 </div>
                  <div class=" project-item">
                     <div class=" projects-image">
                        <img src="@/assets/agence.gif" alt="" srcset="">
                     </div>
                     <div class="project-description">
                         <div class="project-description-text">
                        <p>
                            This is a agence website concept for my practice in web-desing.
                          this website is personal no framework used
                      </p>
                         </div>
                        <div class="description-text">
                            <p class="description-tech-title"> technologie used</p>
                            <ul class="description-tech">
                                <li>HTML5</li>
                                <li>CSS3</li>
                                <li>Javascript</li>
                            </ul>
                        </div>
                        <div class="project-links">
                            
                            <div class="btn">
                                
                                <a href="https://nilaagence.netlify.app/"><span class="btn-light">go to see</span></a>
                            </div>
                            
                        </div>
                     </div>
                 </div>
                 <div class=" project-item">
                     <div class=" projects-image">
                        <img src="@/assets/vue.gif" alt="" srcset="">
                     </div>
                     <div class="project-description">
                         <div class="project-description-text">
                        <p>
                        This is Vue.js front end for watches this project is for practicing my skills in Vue.js it is also a personal project it is just a front end no backend in it.
                      </p>
                         </div>
                        <div class="description-text">
                            <p class="description-tech-title"> technologie used</p>
                            <ul class="description-tech">
                                <li>HTML5</li>
                                <li>CSS3</li>
                                <li>vuejs</li>
                            </ul>
                        </div>
                        <div class="project-links">
                            <div class="btn">
                                
                                <a href="https://github.com/nila884/vue-watches/tree/master"><span class="btn-bg">see code</span></a>
                            </div>
                            <div class="btn">
                                
                                <a href="https://shopwaches.netlify.app/"><span class="btn-light">go to see</span></a>
                            </div>
                            
                        </div>
                     </div>
                 </div>
                 <div class=" project-item">
                     <div class=" projects-image">
                        <img src="@/assets/vuepp.gif" alt="" srcset="">
                     </div>
                     <div class="project-description">
                         <div class="project-description-text">
                        <p>
                            This is a laravel web application it is a backend to manage properties you can create read update and delete data every property is related to multiple image
                      </p>
                         </div>
                        <div class="description-text">
                            <p class="description-tech-title"> technologie used</p>
                            <ul class="description-tech">
                                <li>HTML5</li>
                                <li>CSS3</li>
                                <li>Vuejs</li>
                                <li>Laravel</li>
                            </ul>
                        </div>
                        <div class="project-links">
                            <div class="btn">
                              
                                <a href="https://github.com/nila884/LaravelDemos/tree/master">  <span class="btn-bg">see code</span></a>
                            </div>
                            
                            
                        </div>
                     </div>
                 </div>

                                  <div class=" project-item">
                     <div class=" projects-image">
                        <img src="@/assets/rest.gif" alt="" srcset="">
                     </div>
                     <div class="project-description">
                         <div class="project-description-text">
                        <p>
                          This is a restaurant website concept for my practice in web-desing.
                          this website is personal   no framework used
                      </p>
                         </div>
                        <div class="description-text">
                            <p class="description-tech-title"> technologie used</p>
                            <ul class="description-tech">
                                <li>HTML5</li>
                                <li>CSS3</li>
                                <li>Vuejs</li>
                            </ul>
                        </div>
                        <div class="project-links">
                            <div class="btn">
                               
                                <a href="https://github.com/nila884/restaurent"> <span class="btn-bg">see code</span></a>
                            </div>
                            <div class="btn">
                               
                                <a href="https://niyeraprojectone.netlify.app/"> <span class="btn-light">go to see</span></a>
                            </div>
                            
                        </div>
                     </div>
                 </div>
                                      <div class=" project-item">
                     <div class=" projects-image">
                        <img src="@/assets/codei.gif" alt="" srcset="">
                     </div>
                     <div class="project-description">
                         <div class="project-description-text">
                        <p>
                          This is a codeigniter web app for demo you can create read update and delete article there is some ajax
                      </p>
                         </div>
                        <div class="description-text">
                            <p class="description-tech-title"> technologie used</p>
                            <ul class="description-tech">
                                <li>Codeigniter</li>
                                <li>Boostrap</li>
                                <li>jQuery for ajax operation</li>
                            </ul>
                        </div>
                        <div class="project-links">
                            <div class="btn">
                                
                                <a href="https://github.com/nila884/CodeigniterDemo/tree/master"><span class="btn-bg">see code</span></a>
                            </div>

                            
                        </div>
                     </div>
                 </div>
                 <!-- <div style="margin-top: 2rem;">
                            <div class="btn">
                                <span class="btn-bg">more</span>
                            </div>
                 </div> -->
    </div>
</template>
<script>
export default {
    
}
</script>
